import { formatCurrency, formatPercentage } from '@/utils'

import {
  TableCell,
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { useAtomValue } from 'jotai'
import { topDelegatesAtom } from '../atoms'
import { Skeleton } from '@/components/ui/skeleton'
import { Link } from 'react-router-dom'
import { ExplorerDataType, getExplorerLink } from '@/utils/getExplorerLink'
import { chainIdAtom } from '@/state/atoms'
import EnsName from '@/components/utils/ens-name'
import { Trans } from '@lingui/react/macro'

const GovernanceDelegateList = () => {
  const chainId = useAtomValue(chainIdAtom)
  const delegates = useAtomValue(topDelegatesAtom)

  return (
    <div className="rounded-4xl bg-background ">
      <div className="py-4 px-5">
        <h2 className="font-semibold text-xl ">
          <Trans>Top voting addresses</Trans>
        </h2>
      </div>
      <div className="bg-card m-1 mt-0 rounded-3xl overflow-auto">
        <Table>
          <TableHeader>
            <TableRow className="border-none text-legend">
              <TableHead>
                <Trans>Address</Trans>
              </TableHead>
              <TableHead>
                <Trans>Votes</Trans>
              </TableHead>
              <TableHead>
                <Trans>Vote weight</Trans>
              </TableHead>
              {/* <TableHead>Proposals voted</TableHead> */}
            </TableRow>
          </TableHeader>
          <TableBody>
            {delegates === undefined && (
              <TableRow>
                <TableCell className="text-center text-legend" colSpan={4}>
                  <Skeleton className="h-8 w-full" />
                  <Skeleton className="h-8 mt-2 w-full" />
                  <Skeleton className="h-8 mt-2 w-full" />
                  <Skeleton className="h-8 mt-2 w-full" />
                </TableCell>
              </TableRow>
            )}
            {delegates !== undefined && delegates.length === 0 && (
              <TableRow>
                <TableCell className="text-center text-legend" colSpan={4}>
                  <Trans>No delegates found</Trans>
                </TableCell>
              </TableRow>
            )}
            {delegates &&
              delegates.map((delegate) => (
                <TableRow key={delegate.address}>
                  <TableCell>
                    <Link
                      target="_blank"
                      className="text-legend underline"
                      to={getExplorerLink(
                        delegate.address,
                        chainId,
                        ExplorerDataType.ADDRESS
                      )}
                    >
                      <EnsName address={delegate.address} />
                    </Link>
                  </TableCell>
                  <TableCell>
                    {formatCurrency(delegate.delegatedVotes, 2)}
                  </TableCell>
                  <TableCell>
                    {formatPercentage(delegate.weightedVotes)}
                  </TableCell>
                  {/* <TableCell>{delegate.numberVotes}</TableCell> */}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}

export default GovernanceDelegateList
